import { cashFlowRules } from '../cashFlowRule'
import { describeTable } from './describeTable'

describeTable(cashFlowRules, {
  description: `A recurring cash item the CFO maintains: rent, leasing, insurance, SaaS, net salaries, withholding and social charges. Each rule is materialised into cash_events occurrences (source 'rule') from today to the end of next calendar year; the rule is the definition, the events are the forecast. Re-saving a rule rewrites its occurrences except the ones someone edited (cash_events.overridden_at).`,
  columns: {
    category: 'Free-text bucket copied onto each occurrence.',
    direction: 'in or out.',
    amountNet:
      'Amount before VAT. The occurrence amount is amount_net × (1 + vat_rate).',
    vatRate: 'Decimal VAT rate: 0, 0.14 or 0.255.',
    certainty:
      'expected (default, known recurring cost) or forecast (planned, not yet contracted).',
    interval: "monthly, quarterly or yearly, anchored on start_date's month.",
    dayRule:
      'Day of the month the money moves, 1–31; 31 means the last day of the month.',
    startDate: 'First period. Nothing before today is generated.',
    endDate: 'Last day an occurrence may fall on. Null = open-ended.',
    supplierMatch:
      'When set, an occurrence is skipped for a month that already has a committed fennoa:purchase row whose supplier name contains this text.',
    notes: 'Free text.',
  },
})
